// extracted by mini-css-extract-plugin
export default {"app-market-page":"_1f7wb5u","appMarketPage":"_1f7wb5u","app-market-page-background-color":"_ru6ajz","appMarketPageBackgroundColor":"_ru6ajz"};